/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  index.ts
 */

import { BaseOptions, Logger } from './BaseLogger'
import { ConsoleLogger as DefaultLogger } from './ConsoleLogger'
import { LOG_LEVEL } from './types'

export {
  getGlobalLogger,
  setGlobalLogger,
  setGlobalLogLevel,
} from './globalLogger'

export * from './helpers/getLogLevelFromName'
export * from './BaseLogger'
export * from './ConsoleLogger'
export * from './constants'
export * from './settings'
export * from './types'

export type SetLoggerMethod = (logger: Logger) => void
export type SetLogLevelMethod = (logLevel: LOG_LEVEL) => void

export interface LoggerInterface {
  logger: Logger
  setLogger: SetLoggerMethod
  setLogLevel: SetLogLevelMethod
}

export const createLoggerInterface = (
  options?: BaseOptions
): LoggerInterface => {
  const logger = new DefaultLogger(options)
  return {
    logger,
    setLogger: (...args) => logger?.setLogger?.(...args),
    setLogLevel: (...args) => logger?.setLogLevel?.(...args),
  }
}
